import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import WOW from "wowjs";
import { Icon } from "@iconify/react";
import { Helmet } from "react-helmet-async";
const ContinuumIndia = (props) => {
  useEffect(() => {
    const wow = new WOW.WOW({
      live: false,
    });
    wow.init();
  }, []);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
          <Helmet>
<title>Continuum India | Reversethought</title>
<meta name="description" content="As a mobile app and website development agency in Mumbai, we provide top services for CMS development, UI/ UX Design, and much more. Contact us!" />
        <meta name="robots" content="max-image-preview:large" />
        <meta name="google-site-verification" content="HoCjksaLBwM7qPH8Nt-Rzrqa5K02wXYiJwFSEMC4j8g" />
        <meta name="p:domain_verify" content="f307b6f44d53f755ef67d9a9a3666de7" />
        <meta name="keywords" content="ecommerce website design india,best website development company in india,top website development companies in india,web development company,web development company in india,website development in india,best web design company in mumbai,best web design firms,best website designers in india,top web designing companies in mumbai,top website designers in mumbai,web design agency in mumbai,web design company,web design company india,web design company mumbai,web designing company in mumbai,web development services mumbai,website development agency in india,website development service mumbai" />
<link rel="canonical" href="https://www.reversethought.com/continuum-india" />
        <meta name="generator" content="All in One SEO (AIOSEO) 4.4.7.1" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:site_name" content="Creative Agency In Mumbai | Branding Agency India - Reverse Thought" />
        <meta property="og:type" content="article" />
<meta property="og:title" content=">Continuum India | Reversethought" />
<meta property="og:description" content="We create immersive, intuitive and inspiring websites for desktops and mobiles. Some of our services include interactive E-commerce websites, CMS Development and UI/UX Design." />
<meta property="og:url" content="https://www.reversethought.com/continuum-india" />
        <meta property="article:tag" content="website development in india" />
        <meta property="article:tag" content="best web design company in mumbai" />
        <meta property="article:tag" content="best web design firms" />
        <meta property="article:tag" content="best website designers in india" />
        <meta property="article:tag" content="top web designing companies in mumbai" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@rthoughtindia" />
<meta name="twitter:title" content=">Continuum India | Reversethought" />
<meta name="twitter:description" content="We create immersive, intuitive and inspiring websites for desktops and mobiles. Some of our services include interactive E-commerce websites, CMS Development and UI/UX Design." />
        <meta name="google" content="nositelinkssearchbox" />
      </Helmet>

      <section className="ourWork">
        <div className="content_container">
          <h1 className="projectHeading colorBlack fw-800 text-center wow animate__animated animate__fadeIn">
            Continuum India
          </h1>
          <img
            src="/images/works/websites/continuumindia/OnPaste1.jpg"
            alt="continuumindia"
            className="img-fluid wow animate__animated animate__fadeIn"
          />
          <div className="gridSystem">
            <div className="gridSystemInner">
              {/* <h2 className="colorBlueeeee fw-800 wow animate__animated animate__fadeIn">   ----02/01/24
                Brief
              </h2>
              <p className="colorGrey fw-400 wow animate__animated animate__fadeInLeft">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur.
              </p> */}
              <div className="row m-0 briefDetails wow animate__animated animate__fadeIn">
                <div className="col-sm-6 p-0 briefDetailsInner wow animate__animated animate__fadeInLeft">
                  <h4 className="colorBlack fw-800">Client</h4>
                  <span className="colorGrey fw-400">Continuum India</span>
                </div>
                <div className="col-sm-6 p-0 briefDetailsInner wow animate__animated animate__fadeInLeft">
                  <h4 className="colorBlack fw-800">Industry</h4>
                  <span className="colorGrey fw-400">Media </span>
                </div>
                <div className="col-sm-6 p-0 briefDetailsInner wow animate__animated animate__fadeInRight">
                  <h4 className="colorBlack fw-800">Work</h4>
                  <span className="colorGrey fw-400">
                    Web design and Development
                  </span>
                </div>
                <div className="col-sm-6 p-0 briefDetailsInner wow animate__animated animate__fadeInRight">
                  <h4 className="colorBlack fw-800">Technology</h4>
                  <span className="colorGrey fw-400">
                    HTML5, PHP, CSS3, JS, MySQL
                  </span>
                </div>
              </div>
              <Link
                to="https://www.continuumindia.com/"
                className="unsetAll"
                target="_blank"
                onMouseEnter={props.onMouseEnterSmall}
                onMouseLeave={props.onMouseLeaveSmall}
              >
                <span className="commonViewAll colorBlue linksYw_hover">Check website</span>
                <Icon icon="clarity:arrow-line" />
              </Link> 
            </div>
            <div className="gridSystemInner">
              <div className="d-flex customGap">
                <img
                  src="/images/works/websites/continuumindia/mobi2.jpg"
                  alt="continuumindia UI"
                  className="img-fluid w-100 wow animate__animated animate__fadeInRight"
                />
                <img
                  src="/images/works/websites/continuumindia/mobi1.jpg"
                  alt="continuumindia UI"
                  className="img-fluid w-100 wow animate__animated animate__fadeInRight"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="serviceImageSection"
        onMouseEnter={props.mouseEnterOnBlack}
        onMouseLeave={props.mouseLeaveOnBlack}
      >
        <div className="content_container">
          <div className="row m-0">
            <div className="col-sm-6 p-0 leftImg wow animate__animated animate__slideInLeft">
              <img
                src="/images/works/websites/continuumindia/01.jpg"
                alt="service2"
                className="w-100 h-100"
              />
            </div>
            <div className="col-sm-6 p-0 rightImg wow animate__animated animate__slideInRight">
              <img
                src="/images/works/websites/continuumindia/07.jpg"
                alt="service3"
                className="w-100"
              />
              <img
                src="/images/works/websites/continuumindia/09.jpg"
                alt="service4"
                className="w-100"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="ourWorkSlider wow animate__animated animate__slideInLeft">
        <div className="content_container">
          <h2 className="sectionHead colorBlack fw-800 wow animate__animated animate__fadeIn">
            <img src="/images/icons/line.jpg" alt="line" />
            More Works
          </h2>
          <Slider {...settings}>
            <div>
              <div className="sliderInner">
                <a href="/welspun" className="text-decoration-none">
                <div className="imgHoverEffect position-relative">
                  <a
                    href="/welspun"
                    className="colorWhite fw-800"
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    View Projects &nbsp;
                    <img
                      src="/images/icons/topArrowWhite.svg"
                      alt="toparrow"
                      className="img-fluid"
                    />
                  </a>
                  <img src="/images/cards/web/welpsunindia.jpg" alt="work" />
                </div>
                <h2 className="colorBlack fw-800">Welpsun </h2>
                <span className="colorGrey fw-400">Website Design</span>
                </a>
              </div>
            </div>
            <div>
              <div className="sliderInner">
                <a href="/goodricke" className="text-decoration-none">
                <div className="imgHoverEffect position-relative">
                  <a
                    href="/goodricke"
                    className="colorWhite fw-800"
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    View Projects &nbsp;
                    <img
                      src="/images/icons/topArrowWhite.svg"
                      alt="toparrow"
                      className="img-fluid"
                    />
                  </a>
                  <img src="/images/cards/web/goodricke.jpg" alt="work" />
                </div>
                <h2 className="colorBlack fw-800">Goodricke</h2>
                <span className="colorGrey fw-400">Website Design</span>
                </a>
              </div>
            </div>
            <div>
              <div className="sliderInner">
                <a href="/elleyselectrics" className="text-decoration-none">
                <div className="imgHoverEffect position-relative">
                  <a
                    href="/elleyselectrics"
                    className="colorWhite fw-800"
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    View Projects &nbsp;
                    <img
                      src="/images/icons/topArrowWhite.svg"
                      alt="toparrow"
                      className="img-fluid"
                    />
                  </a>
                  <img src="/images/cards/web/ellys.jpg" alt="work" />
                </div>
                <h2 className="colorBlack fw-800">Elleys’ Electrics</h2>
                <span className="colorGrey fw-400">Website Design</span>
                </a>
              </div>
            </div>
            <div>
              <div className="sliderInner">
                <a href="/nagarkot-logistics" className="text-decoration-none">
                <div className="imgHoverEffect position-relative">
                  <a
                    href="/nagarkot-logistics"
                    className="colorWhite fw-800"
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    View Projects &nbsp;
                    <img
                      src="/images/icons/topArrowWhite.svg"
                      alt="toparrow"
                      className="img-fluid"
                    />
                  </a>
                  <img src="/images/cards/web/nagarkot.jpg" alt="work" />
                </div>
                <h2 className="colorBlack fw-800">Nagarkot Logistics</h2>
                <span className="colorGrey fw-400">Website Design</span>
                </a>
              </div>
            </div>
          </Slider>
          <Link
            to="/works"
            className="unsetAll"
            onClick={() => window.scrollTo(0, 0)}
            onMouseEnter={props.onMouseEnterSmall}
            onMouseLeave={props.onMouseLeaveSmall}
          >
            <span className="commonViewAll colorBlue linksYw_hover">View Our Projects</span>
            <Icon icon="clarity:arrow-line" />
          </Link>
        </div>
      </section>
    </>
  );
};

export default ContinuumIndia;
